// Centralized constants
export const MAX_FILE_BYTES = 50 * 1024 * 1024; // 50 MB

export default { MAX_FILE_BYTES };
